module.exports = __webpack_public_path__ + "img/pri.0811a051.svg";